import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { gaPageView } from "../../lib/analytics";

// Sets document title + meta description per page for SEO, and sends a GA4 page_view.
export default function Seo({ title, description }) {
  const { pathname } = useLocation();
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
    gaPageView(pathname);
  }, [title, description, pathname]);
  return null;
}
